<div class="search-container">

    <div class="search">
        <input type="text" placeholder="Search Invoice Number" [(ngModel)]="searchText" (keydown.enter)="search()" (focus)="focus()" />
        <i nz-icon nzType="search"  nzTheme="outline" (click)="search()"></i>
    </div>

    <div class="search-results" *ngIf="show">
        <div>
            <div class="list-header">
                <h5 *ngIf="SELECTED_LENGTH() > 0">{{ SELECTED_LENGTH() }} selected</h5>
            </div>
            <div>
                <ul>

                    <li class="view-more" *ngIf="invoices.length == 0"> <nz-empty></nz-empty></li>

                    <li class="list-results" *ngFor="let invoice of invoices" [class.selected]="ifSelected(invoice)" (click)="selected(invoice)">
                        <div class="list-results-first">
                            <div>
                                {{ invoice?.CarrierName }} {{ invoice?.ClientCity }}
                            </div>
                            <div class="due-date">{{ invoice?.DueDate | date: 'dd/MMM/yyyy' }}</div> 
                        </div> 
                        <div class="list-result-bottom">{{ invoice?.InvoiceNo }}</div>
                        <div class="list-result-bottom" *ngIf="invoice?.ClientCode">({{ invoice?.ClientCode }})</div>           
                        <div class="list-result-bottom">{{ invoice?.Currency }} {{ invoice?.BilledAmount }} </div>   
                    </li>

                    <li class="view-more" *ngIf="invoices.length > 0">
                        <span *ngIf="page > 1" (click)="prev()">Previous</span>
                        <span *ngIf="invoices?.length >= 15" (click)="view()">View More</span>
                        <span class="clear" (click)="clearSelected()">Clear All</span>
                        <span (click)="emitSelection()">SHOW</span>
                    </li>
                </ul>
            </div>
        </div>

    </div>    
</div>